<template>
    <div>
        <GridColumnMenuCheckboxFilter :column="column" :filter="filter" :filterable="filterable" :unique-data="uniqueData"
            :search-box="false" :data-items="it" :expanded="true" @filterchange="filterChange" @expandchange="expandChange"
            @closemenu="closeMenu" />
    </div>
</template>
<script>
import { GridColumnMenuCheckboxFilter } from '@progress/kendo-vue-grid';

export default {
    props: {
        column: Object,
        filter: Object,
        filterable: Boolean,
        uniqueData: {
            type: Boolean,
            default: true
        },
        items: Array
    },
    data() {
        return {

        };
    },
    computed: {
        it() {
            return [
                {
                    companyInfoField: "已停用",
                    productInfoField:"已停用"
                },
                {
                    companyInfoField: "已上架",
                    productInfoField:""
                },
                {
                    companyInfoField: "待審批"
                },
                {
                    companyInfoField: "已駁回"
                },
                {
                    companyInfoField: "未提交"
                },
                {
                    companyInfoField: "無廣告"
                }
            ];
        }
    },
    components: {
        'GridColumnMenuCheckboxFilter': GridColumnMenuCheckboxFilter
    },
    methods: {
        expandChange() {
            this.$emit('expandchange');
        },
        closeMenu() {
            this.$emit('closemenu');
        },
        filterChange(newDescriptor, e) {
            this.$emit('filterchange', newDescriptor, e);
        }
    }
}
</script>